// extracted by mini-css-extract-plugin
export var errorBanner = "_i7-2";
export var scroller = "_i7-0";
export var thinking = "_i7-1";
export var visuallyHidden = "_i7-3";